import { render, staticRenderFns } from "./WxLoginModel.vue?vue&type=template&id=78533247&scoped=true"
import script from "./WxLoginModel.vue?vue&type=script&lang=js"
export * from "./WxLoginModel.vue?vue&type=script&lang=js"
import style0 from "./WxLoginModel.vue?vue&type=style&index=0&id=78533247&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78533247",
  null
  
)

export default component.exports